export const replaceNumberQuestion = (str) => { 
  return str.split('q').join("")
}

export const shortStringToTiptool = (str,maxLength) => {  
  if(str.length < maxLength) return str
  const s_str = str.substring(0,maxLength)
  return s_str + "..."
}
export const cutTailNumber = (str) => {  
  if(str.length <= 0) return str   
  var _str = str.split("_") 
  return _str[0] 
}